import React, { useCallback, useEffect, useRef } from 'react';

import { axisBottom, axisLeft } from 'd3-axis';
import { select } from 'd3-selection';

import COLORS from '../../../../constants/colors.constants';

const GridAxis = ({
  id,
  scale,
  orient,
  ticks,
  tickSize,
  tickValues,
  transform,
  clipPath,
}) => {
  const axisRef = useRef();

  const renderAxis = useCallback(() => {
    let axis;

    if (orient === 'bottom') {
      axis = axisBottom(scale);
    }
    if (orient === 'left') {
      axis = axisLeft(scale);
    }

    if (ticks) {
      axis.ticks(ticks);
    } else if (tickValues) {
      axis.tickValues(tickValues);
    }

    // Sets the size of the grid lines
    axis.tickSizeInner(tickSize)
      .tickSizeOuter(0)
      .tickFormat('');

    // Adjust Grid Line Styling
    select(axisRef.current)
      .call(axis)
      .attr('font-size', 0)
      .selectAll('.tick line')
      .attr('stroke', COLORS.border.light)
      .attr('clip-path', clipPath);

    // Make axis lines invisible
    select(axisRef.current)
      .select('.domain')
      .attr('opacity', 0)
  }, [clipPath, orient, scale, tickSize, tickValues, ticks])

  // Initial Render
  useEffect(() => {
    renderAxis();
  }, [renderAxis])

  return (
    <g
      id={id}
      ref={axisRef}
      transform={transform}
      className={`${orient}-grid-axis`}
    />
  );
}

export default GridAxis;
